export const getCursorState = (resData, rowCount) => {
  const hasCursor = resData?.next_offset !== undefined;
  return {
    hasCursor,
    nextOffset: hasCursor ? resData.next_offset : null,
    exhausted: hasCursor ? resData.next_offset == null : rowCount === 0,
  };
};

export const getFilteredOffset = (pageNumber, nextOffset, limit) =>
  pageNumber > 1 && nextOffset != null ? nextOffset : (pageNumber - 1) * limit;
